import React from 'react';
import { theme, websiteColors } from "./../themes/Theme";

const Banner = ({ bannerData }) => {
    return (
        <div>
            {
                bannerData.map((banner) => (
                    <div className='px-4 pb-4 my-5 mt-lg-0'>
                        <div className="app-banner m-lg-auto m-xl-auto  d-flex justify-content-between align-items-center px-4 py-2">
                            <div className='d-flex flex-column'>
                                {
                                    banner.sectionText &&
                                    (
                                        <div className="d-flex">
                                            <p className="banner-app-section-text mb-0">{banner.sectionText}</p>
                                        </div>
                                    )
                                }
                                <div className="d-flex align-items-center">
                                    <h5 className="text-white banner-app-heading mb-0">{banner.title}</h5>
                                </div>
                            </div>
                            <div className="d-flex align-items-center">
                                <a target='_blank' href={banner.button.link} className="btn btn-light explore-btn">
                                    {banner.button.name}
                                </a>
                            </div>
                        </div>
                    </div>
                ))
            }



            <style jsx>
                {`
                    .app-banner {
                        background-color: ${websiteColors[theme].primaryWebsiteTheme}; 
                        padding: 30px !important;
                        border: 1px solid #61C0FF;
                        max-width: 1200px;
                    }
                    .banner-app-heading {
                        font-size: 32px;
                        font-weight: 600;
                        line-height: 44px;
                    }
                    .banner-app-section-text{
                        color: #C5E2FF;
                    }
                    .explore-btn {
                        padding: 5px 40px;
                        font-size: 16px;
                        font-weight: 700;
                        line-height: 28px;
                        letter-spacing: 2px;
                        color: ${websiteColors[theme].primaryWebsiteTheme};
                        white-space: nowrap;
                    }
                    @media screen and (max-width: 992px) {
                        .banner-app-heading {
                            line-height: 48px;
                        }
                    }
                    @media screen and (max-width: 576px) {
                        .app-banner {
                            display: flex;
                            flex-direction: column !important;
                            align-items: flex-start !important;
                            justify-content: flex-start !important;
                            gap: 15px;
                        }
                        .banner-app-heading {
                            font-size: 20px;
                            font-weight: 600;
                            line-height: 30px;
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default Banner;
